class HeaderNavigation {
  header = document.getElementsByClassName('del-header')[0];

  stripe = document.getElementsByClassName('del-stripe__container')[0];

  wrapper = document.getElementsByClassName('del-header__wrapper-container')[0];

  burgerMenuButton = document.getElementById('js-del-header-burgerMenuButton');

  categoryMenu = document.getElementById(`js-del-categoryMenu`);

  categoryOptions = document.getElementsByClassName(
    'del-header__navbar--listElement',
  );

  categoryNavOptions = document.getElementsByClassName(
    'del-header__navbar--navElement',
  );

  categoryScreens = document.getElementsByClassName(`del-header__category`);

  categoryScreenFillers = document.querySelectorAll(
    '.del-header__category > .del-header__filler',
  );

  categoryScreenCloseButtons = document.getElementsByClassName(
    'del-header__close-header',
  );

  categoryBackButton = document.getElementsByClassName(
    'js-del-category-backButton',
  );

  subcategoryMenu = document.getElementById(`js-del-subcategoryMenu`);

  subcategoryOptions = document.getElementsByClassName(
    'del-category__navbar--listElement',
  );

  subcategoryScreens = document.getElementsByClassName(
    `del-header__subcategory`,
  );

  subcategoryBackButton = document.getElementsByClassName(
    'js-del-subcategory-backButton',
  );

  checkScrollSpeed = (settings => {
    settings = settings || {};

    let lastPos;
    let newPos;
    let timer;
    let delta;
    const delay = settings.delay || 1000; // in "ms" (higher means lower fidelity )

    function clear() {
      lastPos = null;
      delta = 0;
    }

    clear();

    return () => {
      newPos = window.scrollY;
      if (lastPos != null) {
        delta = newPos - lastPos;
      }
      lastPos = newPos;
      clearTimeout(timer);
      timer = setTimeout(clear, delay);
      return delta;
    };
  })();

  isAnyCategoryVisible = () => {
    let isVisible = false;
    [...this.categoryScreens].forEach(screen => {
      if (!screen.classList.contains('del-header__category--hidden')) {
        isVisible = true;
      }
    });
    return isVisible;
  };

  isCategoryMenuVisible = () =>
    !this.categoryMenu.classList.contains('del-header__category--hidden');

  isAnyScreenVisible = () =>
    this.isCategoryMenuVisible() || this.isAnyCategoryVisible();

  hideCategoryMenu = () => {
    this.categoryMenu.classList.add('del-header__category--hidden');
  };

  showCategoryMenu = () => {
    [...this.categoryScreens].forEach(cat => {
      if (!cat.classList.contains('del-header__category--hidden')) {
        cat.classList.add('del-header__category--hidden');
      }
    });
    if (this.categoryMenu.classList.contains('del-header__category--hidden')) {
      this.categoryMenu.classList.remove('del-header__category--hidden');
      const closeButton = this.categoryMenu.querySelector(
        '.del-header__close-header',
      );
      if (closeButton) {
        closeButton.focus();
      }
    }
  };

  selectCategoryOption = option => {
    [...this.categoryNavOptions].forEach(item => {
      item.classList.remove('del-option--selected');
      const categoryButton = item.querySelector('button');
      if (categoryButton) {
        categoryButton.setAttribute('aria-expanded', false);
      }
    });
    if (
      option &&
      !option.classList.contains('del-header__navbar--notShowCategoryScreen')
    ) {
      option.classList.add('del-option--selected');
      const categoryButton = option.querySelector('button');
      if (categoryButton) {
        categoryButton.setAttribute('aria-expanded', true);
      }
    }
  };

  showCategoryScreen = categoryId => {
    [...this.categoryScreens].forEach(cat => {
      if (!cat.classList.contains('del-header__category--hidden')) {
        cat.classList.add('del-header__category--hidden');
      }
    });
    if (categoryId) {
      this.hideCategoryMenu();
      const categoryScreen = document.getElementById(
        `js-del-category--${categoryId}`,
      );
      categoryScreen.classList.remove('del-header__category--hidden');
      const closeButton = categoryScreen.querySelector(
        '.del-header__close-header',
      );
      if (closeButton) {
        closeButton.focus();
      }
    }
  };

  hideSubcategoryMenu = () => {
    if (!this.subcategoryMenu.classList.contains('del-mobile-hidden')) {
      this.subcategoryMenu.classList.add('del-mobile-hidden');
    }
  };

  showSubcategoryMenu = () => {
    [...this.subcategoryScreens].forEach(cat => {
      cat.style.display = 'none';
    });
    if (this.subcategoryMenu.classList.contains('del-mobile-hidden')) {
      this.subcategoryMenu.classList.remove('del-mobile-hidden');
    }
  };

  hideCategoryScreenMenu = () => {
    const optionButton = document.querySelector('.del-option--selected');
    if (optionButton) {
      optionButton.click();
    }
  };

  selectSubcategoryOption = option => {
    [...this.subcategoryOptions].forEach(item => {
      item.classList.remove('del-option--selected');
      item.querySelector('button').setAttribute('aria-expanded', false);
    });
    option.classList.add('del-option--selected');
    option.querySelector('button').setAttribute('aria-expanded', true);
  };

  showSubcategoryScreen = subcategoryId => {
    [...this.subcategoryScreens].forEach(cat => {
      cat.style.display = 'none';
    });
    this.hideSubcategoryMenu();
    const subcategoryScreen = document.getElementById(
      `js-del-subcategory--${subcategoryId}`,
    );
    subcategoryScreen.removeAttribute('style');
  };

  attachEventListeners = () => {
    window.onscroll = () => {
      if (!this.wrapper.classList.contains('del-header--menuopen')) {
        const scrollSpeed = this.checkScrollSpeed();
        if (scrollSpeed < -30 || window.scrollY === 0) {
          if (
            this.header.classList.contains('del-header--hiddenByDefault') &&
            this.header.classList.contains('del-header--hidden') &&
            !this.header.classList.contains('del-header--visible')
          ) {
            this.header.classList.add('del-header--visible');
            this.header.classList.remove('del-header--hidden');
            document.body.classList.remove('del-header--hidden');
            setTimeout(
              () => this.header.classList.remove('del-header--visible'),
              300,
            );
          }
        } else if (scrollSpeed > 0) {
          if (
            this.header.classList.contains('del-header--hiddenByDefault') &&
            !this.header.classList.contains('del-header--hidden')
          ) {
            this.header.classList.add('del-header--hidden');
            document.body.classList.add('del-header--hidden');
          }
        }
      }
      if (window.scrollY > 50) {
        if (
          this.wrapper.classList.contains('del-header--transparent') &&
          !this.wrapper.classList.contains('del-header--standard')
        ) {
          this.wrapper.classList.add('del-header--standard');
        }
      } else if (
        this.wrapper.classList.contains('del-header--transparent') &&
        this.wrapper.classList.contains('del-header--standard')
      ) {
        this.wrapper.classList.remove('del-header--standard');
      }

      if (this.stripe) {
        if (window.scrollY === 0) {
          if (this.stripe.classList.contains('del-stripe--hidden')) {
            this.stripe.classList.remove('del-stripe--hidden');
            document.body.classList.remove('del-stripe--hidden');
          }
        } else if (!this.stripe.classList.contains('del-stripe--hidden')) {
          this.stripe.classList.add('del-stripe--hidden');
          document.body.classList.add('del-stripe--hidden');
        }
      }
    };

    if (this.burgerMenuButton) {
      this.burgerMenuButton.addEventListener('click', () => {
        if (!this.isAnyScreenVisible()) {
          this.showCategoryMenu();
          this.burgerMenuButton.classList.remove('icon-menu');
          this.burgerMenuButton.classList.add('icon-menu-close');
        } else {
          this.showCategoryMenu();
          this.hideCategoryMenu();
          this.burgerMenuButton.classList.remove('icon-menu-close');
          this.burgerMenuButton.classList.add('icon-menu');
        }
      });
    }

    [...this.categoryScreens].forEach(screen => {
      screen.addEventListener('keydown', e => {
        if (
          e.key === 'Escape' &&
          !screen.classList.contains('del-header__category--hidden')
        ) {
          this.selectCategoryOption();
          this.showCategoryScreen();
          const screenButton = this.wrapper.querySelector(
            `button[aria-labelledby="${screen.id}"]`,
          );
          if (screenButton) {
            screenButton.focus();
          }
        }
      });
    });

    [...this.categoryOptions].forEach(option => {
      if (
        !option.classList.contains('del-header__navbar--notShowCategoryScreen')
      ) {
        option.addEventListener('keydown', e => {
          if (
            e.key === 'Escape' &&
            !option.classList.contains('del-header__category--hidden')
          ) {
            this.showCategoryScreen(option.dataset.id);
          }
        });
        option.addEventListener('click', () =>
          this.showCategoryScreen(option.dataset.id),
        );
      }
    });

    [...this.categoryNavOptions].forEach(option => {
      option.addEventListener('keydown', e => {
        const currentOptionScreen = document.getElementById(
          `js-del-category--${option.dataset.id}`,
        );
        if (
          e.key === 'Escape' &&
          !currentOptionScreen.classList.contains(
            'del-header__category--hidden',
          )
        ) {
          if (this.wrapper.classList.contains('del-header--menuopen')) {
            this.wrapper.classList.remove('del-header--menuopen');
          }
          option.classList.remove('del-option--selected');
          option.querySelector('button').setAttribute('aria-expanded', false);
          currentOptionScreen.classList.add('del-header__category--hidden');
        }
      });
      option.addEventListener('click', () => {
        const currentOptionScreen = document.getElementById(
          `js-del-category--${option.dataset.id}`,
        );
        if (
          currentOptionScreen?.classList.contains(
            'del-header__category--hidden',
          )
        ) {
          if (!this.wrapper.classList.contains('del-header--menuopen')) {
            this.wrapper.classList.add('del-header--menuopen');
          }
          this.selectCategoryOption(option);
          this.showCategoryScreen(option.dataset.id);

          if (this.subcategoryOptions.length > 0) {
            [...this.subcategoryOptions].forEach(item => {
              item.classList.remove('del-option--selected');
              item.querySelector('button').setAttribute('aria-expanded', false);
            });
            [...this.subcategoryOptions][0].classList.add(
              'del-option--selected',
            );
            [...this.subcategoryOptions][0]
              .querySelector('button')
              .setAttribute('aria-expanded', true);
            [...this.subcategoryScreens].forEach(screen => {
              screen.style.display = 'none';
            });
            [...this.subcategoryScreens][0].removeAttribute('style');
          }
        } else {
          if (this.wrapper.classList.contains('del-header--menuopen')) {
            this.wrapper.classList.remove('del-header--menuopen');
          }
          option.classList.remove('del-option--selected');
          const categoryButton = option.querySelector('button');
          if (categoryButton) {
            categoryButton.setAttribute('aria-expanded', false);
          }
          if (currentOptionScreen)
            currentOptionScreen.classList.add('del-header__category--hidden');
        }
      });
    });

    [...this.categoryBackButton].forEach(btn => {
      btn.addEventListener('click', () => this.showCategoryMenu());
    });

    [...this.subcategoryOptions].forEach(option => {
      option.addEventListener('click', () => {
        this.selectSubcategoryOption(option);
        this.showSubcategoryScreen(option.dataset.id);
      });
    });

    [...this.subcategoryBackButton].forEach(btn => {
      btn.addEventListener('click', () => this.showSubcategoryMenu());
    });

    [...this.categoryScreenFillers].forEach(filler => {
      if (filler.querySelector('.del-category')) {
        filler.addEventListener('mouseleave', () => {
          this.hideCategoryScreenMenu();
        });
      }
    });

    [...this.categoryScreenCloseButtons].forEach(option => {
      option.addEventListener('click', () => {
        this.hideCategoryScreenMenu();
      });
    });
  };
}

export default () => {
  if (document.querySelector('.del-header')) {
    const headerMenu = new HeaderNavigation();
    headerMenu.attachEventListeners();
  }
};
